import type { CRMNote, Person } from "@/types";

export enum OrderStage {
  DRAFT = "draft",
  OPEN = "open",
  PENDING = "pending",
  PAID = "paid",
  FAILED = "failed",
  CANCELED = "canceled",
  UNCOLLECTIBLE = "uncollectible",
  OVERDUE = "overdue"
}

export enum OrderPaymentStatus {
  OVERDUE = "overdue",
  FAILED = "payment-failed",
  REFUNDED = "payment-refunded"
}

export enum PaymentStatus {
  PAID = "paid",
  PENDING = "pending",
  FAILED = "failed",
  REFUNDED = "refunded",
  PARTIALLY_REFUNDED = "partially-refunded"
}
export enum PaymentMethod {
  CARD = "card",
  CHECK = "check",
  US_BANK_ACCOUNT = "us_bank_account",
  FINANCIAL_ADJUSTMENT = "financial_adjustment"
}

export enum paymentSourceTypes {
  self = "self",
  facility = "facility",
  other = "other"
}

export interface OrderRow {
  id: string;
  status: OrderStage;
  paymentStatus: OrderPaymentStatus;
  description: string;
  person: Person;

  pgaId?: string | undefined;
  payable?: boolean;
  lineItems?: {
    id: string;
    name: string;
    priceCents: number;
    quantity: number;
    totalPrice: number;
  }[];
  notes?: CRMNote[];
}

export interface OrderNode {
  id: string;
  status: OrderStage;
  balance: number;
  dueDate?: string;
  paymentStatus: OrderPaymentStatus;
  payable: boolean;
  updatedAt: string;
  description: string;
  lineItems: {
    id: string;
    name: string;
    priceCents: number;
    quantity: number;
    totalPrice: number;
  }[];
  person: Person;
  notes?: CRMNote[];
}

export type Proration = {
  originalPrice: number;
  proratedNumberOfMonths: number;
  proratedPrice: number;
};

export type Actor =
  | { __typename: "BackofficeUser"; name?: string; email?: string }
  | { __typename: "BackofficeAdminUser"; email?: string }
  | { __typename: "BackofficePerson"; displayName?: string }
  | { __typename: string; [k: string]: unknown };

export type ChangesetItem = {
  typeOfData?: string;
  oldValue?: number | string | null;
  newValue?: number | string | null;
  description?: string;
};

export type CommerceAuditLogEntry = {
  id?: string | number;
  timestamp: string;
  description: string;
  actor?: Actor | null;
  changeset?: ChangesetItem[];
};

export type BalanceChange = {
  oldBalanceCents: number;
  newBalanceCents: number;
};

export type GroupedAuditEvents = {
  timestamp: string;
  events: CommerceAuditLogEntry[];
  balanceChange?: BalanceChange;
};
